import _ from 'lodash';

// Pass in an object and rename some of the keys in it
// Introduced due to ISXCSS-1080 rearrangements
export const renameObjectKeys = (obj: any, countryCode: string) => {
  if (countryCode === 'ae') {
    let newObj = _.mapKeys(obj, (value, key) => {
      switch (key) {
        case 'city':
          return 'streetAddress';
        case 'state':
          return 'city';
        default:
          return;
      }
    });
    newObj['state'] = '';
    delete newObj['undefined'];
    return newObj;
  }

  if (countryCode === 'in' || countryCode === 'kw') {
    let newObj = _.mapKeys(obj, (value, key) => {
      switch (key) {
        case 'state':
          return 'streetAddress2';
        default:
          return;
      }
    });
    newObj['state'] = '';
    delete newObj['undefined'];
    return newObj;
  }

  if (countryCode === 'jo') {
    let newObj = _.mapKeys(obj, (value, key) => {
      switch (key) {
        case 'city':
          return 'streetAddress';
        case 'state':
          return 'city';
        default:
          return;
      }
    });
    newObj['state'] = '';
    delete newObj['undefined'];
    return newObj;
  }

  if (countryCode === 'qa') {
    let newObj = _.mapKeys(obj, (value, key) => {
      switch (key) {
        case 'city':
          return 'streetAddress2';
        case 'state':
          return 'city';
        default:
          return;
      }
    });
    newObj['state'] = '';
    delete newObj['undefined'];
    return newObj;
  }

  return obj;
};

// Make values more readable eg 'ABUDHABI' -> 'Abu Dhabi' for customer and delivery services
export const remapValuesToReadable = (obj: any, countryCode: string) => {
  const mapValue = CSS_CONFIG.MAPVALUES;

  if (countryCode === 'ae') {
    obj['city'] = mapValue[obj['city']];
    return obj;
  }

  if (countryCode === 'om') {
    obj['state'] = mapValue[obj['state']];
  }

  if (countryCode === 'kw') {
    obj['state'] = mapValue[obj['state']];
  }

  if (countryCode === 'qa') {
    obj['state'] = mapValue[obj['state']];
  }

  return obj;
};

// append block value with streetAddress key for specific market like bh
export const appendBlock = (obj: any, countryCode: string) => {
  if (countryCode === 'bh') {
    obj['streetAddress'] = obj['streetAddress'] + ' ' + obj['blockNumber'];
    obj['blockNumber'] = '';
  }

  return obj;
};
